import React from 'react'
import { Chart as ChartJS, CategoryScale, LinearScale, LogarithmicScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import { Bar } from 'react-chartjs-2';


ChartJS.register(CategoryScale, LinearScale, LogarithmicScale, BarElement, Title, Tooltip, Legend);

export default function MyBarChart(props) {
    //backgroundColor: ['#f56954', '#00a65a', '#f39c12', '#00c0ef', '#3c8dbc', '#d2d6de'],
    //                   Merah      Hijau       orange    biru-langit biru-smp  abu-abu
    const isHorizontal = props.indexAxis === "y";
    const data = {
        labels: props.labels,
        datasets: props.data
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: props.indexAxis,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ...(isHorizontal ? { type: props.scaleType, ticks: { beginAtZero: true } } : {})
            },
            y: {
                display: true,
                ...(!isHorizontal ? { type: props.scaleType } : {}),
                grid: {
                    display: false
                },
                ticks: {
                    beginAtZero: true
                }
            }
        }
    };

    return (
        <div className={"card card-" + props.className}>
            <div className="card-header">
                <h3 className="card-title font-nol-koma-sembilan">{props.label}</h3>
                <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus" />
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div style={{ height: props.height, maxHeight: props.maxHeight, overflowY: props.overflowY }}>
                    <Bar options={options} data={data} style={{ minHeight: props.height, height: props.height, maxWidth: '100%' }} />
                </div>
            </div>
        </div>
    )
}

MyBarChart.defaultProps = {
    labels: [],
    label: "",
    data: [],
    className: "primary",
    scaleType: "logarithmic",
    indexAxis: "x",
    height: 250,
    maxHeight: 250,
    overflowY: "visible"
}
